import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { context } from '../../../globalState/GlobalState';
import './css/Events1.css';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import EventThumbnail1 from '../../uiElements/eventAndPracticeThumbnails/eventThumbnail1/EventThumbnail1';
import { EventType } from '../../../catalog/enums/EventType';
import { getLocalTimeFromDatabaseTime, getMonthYearStringFromDate } from '../../../catalog/DateTime';
import { isValidObject } from '../../../catalog/Validity';
import PlaceholderComponent2 from '../../uiElements/placeholderComponents/placeholderComponent2/PlaceholderComponent2';

const EventsEvents1 = (props) => {
    const { events, loadingSpinner, unavailableText } = props;
    const { globalState } = useContext(context);

    const insertMonth = (event, index) => {
        if (index === 0) {
            return <h2 className="events1-month-title text-left-align font-size-2xl m-t-0 m-b-20px text-uppercase">{getMonthYearStringFromDate(getLocalTimeFromDatabaseTime(event.timeOfEvent))}</h2>;
        }
        if (getLocalTimeFromDatabaseTime(event.timeOfEvent).getMonth() !== getLocalTimeFromDatabaseTime(events[index - 1].timeOfEvent).getMonth() || getLocalTimeFromDatabaseTime(event.timeOfEvent).getFullYear() !== getLocalTimeFromDatabaseTime(events[index - 1].timeOfEvent).getFullYear()) {
            return <h2 className="events1-month-title text-left-align font-size-2xl m-t-20px m-b-20px text-uppercase">{getMonthYearStringFromDate(getLocalTimeFromDatabaseTime(event.timeOfEvent))}</h2>;
        }
        return null;
    };

    return (
        <div className="events1-events full-width">
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    {events.length > 0 ? (
                        <>
                            {events.map((event, index) => {
                                return (
                                    <React.Fragment key={event.id}>
                                        {insertMonth(event, index)}
                                        {event.eventType === EventType.EVENT
                                            ? (<EventThumbnail1 id={event.id} articleId={event.articleId} title={event.title} venue={event.venue} timeOfEvent={event.timeOfEvent} endTimeOfEvent={isValidObject(event.endTimeOfEvent) ? event.endTimeOfEvent : event.timeOfEvent} />)
                                            : null}
                                    </React.Fragment>
                                );
                            })}
                        </>
                    ) : (<PlaceholderComponent2 text={unavailableText} />)}
                </>
            )}
        </div>
    );
};

EventsEvents1.propTypes = {
    events: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
    unavailableText: PropTypes.string.isRequired,
};

export default memo(EventsEvents1);
